// extracted by mini-css-extract-plugin
module.exports = {"container":"PageTitle-module--container--2AbP3"};